export default __webpack_public_path__ + "static/media/About-detail.24cac084.svg";